import { ChevronRightIcon } from "./icons";

/**
 * Bloco do checkout no celular: título, uma ação opcional à direita e o
 * conteúdo num cartão.
 */
export default function CheckoutSection({ id, title, action, children }) {
  return (
    <section id={id} className="checkout-section" aria-label={title}>
      {(title || action) && (
        <header className="checkout-section__header">
          {title && <h2 className="checkout-section__title">{title}</h2>}
          {action}
        </header>
      )}
      <div className="checkout-section__card">{children}</div>
    </section>
  );
}

/**
 * Linha de escolha dentro de uma seção (pagamento, cupom, horário): ícone,
 * o que está escolhido e a ação. A linha inteira é o botão.
 */
export function CheckoutRow({
  icon,
  title,
  children,
  actionLabel,
  onClick,
  disabled = false,
}) {
  return (
    <button
      type="button"
      className="checkout-row"
      onClick={onClick}
      disabled={disabled}
    >
      {icon && <span className="checkout-row__icon">{icon}</span>}
      <span className="checkout-row__body">
        <span className="checkout-row__title">{title}</span>
        {children}
      </span>
      <span className="checkout-row__action">
        {actionLabel}
        <ChevronRightIcon fontSize="small" />
      </span>
    </button>
  );
}
